import { create } from "zustand";

export const useStore = create((set) => ({
  selectedIncidentId: null,
  isPanelOpen: false,
  selectedFmeaId: null,
  isFmeaPanelOpen: false,
  isModalOpen: false,
  isSidebarOpen: false,
  incidentFilter: "all",
  incidentSearch: "",
  fmeaFilter: "all",
  fmeaSearch: "",
  integrationModal: { open: false, type: null, fmeaId: null },
  // 8D
  selectedEightDId: null,
  isEightDPanelOpen: false,
  isNewEightDModalOpen: false,
  newEightDPrefillIncidentId: null,
  // LPA
  selectedLpaId: null,
  isLpaPanelOpen: false,
  isNewLpaModalOpen: false,
  newLpaPrefillIncidentId: null,
  // Settings toggles
  autoTriggerLpa: false,
  autoOfferEightD: true,
  toasts: [],
  wsStatus: "idle",
  setWsStatus: (s) => set({ wsStatus: s }),

  // Iter22 — AI Next Steps wire-in helpers
  // Service Request modal: when AI suggests one, pre-open + pre-select sr_type
  srPreset: { incidentId: null, type: null },
  openSrModalWithType: (incidentId, type) =>
    set({ srPreset: { incidentId, type } }),
  clearSrPreset: () => set({ srPreset: { incidentId: null, type: null } }),

  // Comment input prefill (text + optional mention name). The IncidentPanel
  // reads this on render, applies it, then calls clearCommentPrefill().
  commentPrefill: { incidentId: null, text: "", mention: null, version: 0 },
  setCommentPrefill: (incidentId, text, mention = null) =>
    set((s) => ({
      commentPrefill: {
        incidentId,
        text,
        mention,
        version: s.commentPrefill.version + 1,
      },
    })),
  clearCommentPrefill: () =>
    set({ commentPrefill: { incidentId: null, text: "", mention: null, version: 0 } }),

  // SITROOM Copilot floating panel
  isCopilotOpen: false,
  openCopilot: () => set({ isCopilotOpen: true }),
  closeCopilot: () => set({ isCopilotOpen: false }),
  toggleCopilot: () => set((s) => ({ isCopilotOpen: !s.isCopilotOpen })),

  // Briefing modal (login + manual reopen)
  isBriefingOpen: false,
  openBriefing: () => set({ isBriefingOpen: true }),
  closeBriefing: () => set({ isBriefingOpen: false }),

  openPanel: (id) => set({ selectedIncidentId: id, isPanelOpen: true }),
  closePanel: () => set({ isPanelOpen: false }),

  openFmeaPanel: (id) => set({ selectedFmeaId: id, isFmeaPanelOpen: true }),
  closeFmeaPanel: () => set({ isFmeaPanelOpen: false }),

  openModal: () => set({ isModalOpen: true }),
  closeModal: () => set({ isModalOpen: false }),

  setSidebarOpen: (v) => set({ isSidebarOpen: v }),
  toggleSidebar: () => set((s) => ({ isSidebarOpen: !s.isSidebarOpen })),

  setIncidentFilter: (f) => set({ incidentFilter: f }),
  setIncidentSearch: (q) => set({ incidentSearch: q }),

  setFmeaFilter: (f) => set({ fmeaFilter: f }),
  setFmeaSearch: (q) => set({ fmeaSearch: q }),

  openIntegrationModal: (type, fmeaId) =>
    set({ integrationModal: { open: true, type, fmeaId } }),
  closeIntegrationModal: () =>
    set({ integrationModal: { open: false, type: null, fmeaId: null } }),

  openEightDPanel: (id) => set({ selectedEightDId: id, isEightDPanelOpen: true }),
  closeEightDPanel: () => set({ isEightDPanelOpen: false }),
  openNewEightDModal: (incidentId = null) =>
    set({ isNewEightDModalOpen: true, newEightDPrefillIncidentId: incidentId }),
  closeNewEightDModal: () =>
    set({ isNewEightDModalOpen: false, newEightDPrefillIncidentId: null }),

  openLpaPanel: (id) => set({ selectedLpaId: id, isLpaPanelOpen: true }),
  closeLpaPanel: () => set({ isLpaPanelOpen: false }),
  openNewLpaModal: (incidentId = null) =>
    set({ isNewLpaModalOpen: true, newLpaPrefillIncidentId: incidentId }),
  closeNewLpaModal: () =>
    set({ isNewLpaModalOpen: false, newLpaPrefillIncidentId: null }),

  setAutoTriggerLpa: (v) => set({ autoTriggerLpa: v }),
  setAutoOfferEightD: (v) => set({ autoOfferEightD: v }),

  addToast: (toast) =>
    set((s) => {
      // Iter51 — cap visible toast stack at 5 (drop oldest); manual close only.
      const next = [...s.toasts, { id: Date.now() + Math.random(), ...toast }];
      return { toasts: next.length > 5 ? next.slice(next.length - 5) : next };
    }),
  removeToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
